import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://btjlbxreyfzsdujvzpet.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ0amxieHJleWZ6c2R1anZ6cGV0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg2NjQyNDQsImV4cCI6MjA3NDI0MDI0NH0.giFM7h-oCJ9iaxbPpX9NubA6DzoFBcMMawq19SCZehI";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: false, // Site público não precisa de sessão
    autoRefreshToken: false,
  },
});
